import React, {Fragment} from 'react';
import Link from 'react-router-dom/Link';
import { Row, Col, List, Avatar, Icon, Button } from 'antd';
import './MarketGrowthSection.css';
import imgMarketGrowth from '../../images/business-561387_1920.jpg';

const data = [
  { 
    title: 'Opportunities for future growth could reach over $29 billion/year in the US alone',
    
  },
  {
    title: 'One study estimated telehealth had the potential to save $6 billion for employers',
  },
  {
    title: 'Over 400 million ambulatory-care visits per year in the US could be addressed with telemedicine.',
  },
  {
    title: 'An estimated 140+ million behavioral health doctor visits could be handled by telehealth appplications. ',
  },
];

const MarketGrowthSection = (props) => {

   return (
      <Fragment>
      <div className="MarketGrowthSection--container">
        
        <div className="MarketGrowthSection--container-inner img-rounded">
          <div className="MarketGrowthSection--headline">
            <h2> 
              <Icon type="area-chart" style={{marginRight:15}}/> A Global Market Worth Billions ... and Growing!
            </h2>
          </div>
          <Row>
            <Col sm ={24} md={8} style={{float:'left'}}>
              <Link to="/market/">
              <div className="MarketGrowthSection--image">
                <img className="MarketGrowthSection--img-main img-responsive img-rounded" alt="growth" src={imgMarketGrowth} />
              </div>
              </Link>
            </Col>
            <Col sm={24} md={16}>
              <div className="MarketGrowthSection--description">
                <div className="MarketGrowthSection--subheadline">
                    Join the Telemedicine revolution and experience rapid market growth!
                </div>
                <div className="MarketGrowthSection--body-text">
                  <p>
                    Real Time Touch has the intellectual property to help take advantage of this market.
                  </p>
                  <p>
                    We're seeking partners to develop this innovative mobile health patent in a billion+ dollar growing market.
                  </p>
                  <div className="MarketGrowthSection--container-list">
                    <List 
                      itemLayout="horizontal"
                      dataSource={data}
                      renderItem={item => (
                        <List.Item>
                          <List.Item.Meta
                            avatar={<Avatar icon="area-chart" />}
                            title={<span className="MarketGrowthSection--list-item-headline">{item.title}</span>}
                            description=""
                          />
                        </List.Item>
                      )}
                    />
                  </div>

                  {/* <p>
                  The opportunities available with Real Time Touch intellectual property are tremendous. 
                  </p> */}

                </div>
              </div>            
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div className="MarketGrowthSection--button-moreinfo">
                <Link to="/market/">
                  <Button size="large" type="danger"><Icon type="area-chart" style={{marginRight:5}}/>Market Growth Statistics<Icon type="caret-right" /></Button>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      </Fragment>
    )
 }

 export default MarketGrowthSection;


// WEBPACK FOOTER //
// ./src/containers/MarketGrowthSection/MarketGrowthSection.js